import React from 'react';
import ScrollTop from './ScrollTop';

const ClickToTop = () => {
    return (
      <div className="radius-20 bg-inherit text-green-900">
        <ScrollTop></ScrollTop>
      </div>
    );
};

export default ClickToTop;